<template>
  <div class="orderList">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="128px"
        :model="formInline"
        inline
      >
        <el-form-item prop="skuName" label="班级名称">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.skuName"
            placeholder="请输入班级名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="orderNumber" label="订单号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.orderNumber"
            placeholder="请输入订单号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="outTradeNo" label="渠道侧订单号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.outTradeNo"
            placeholder="请输入渠道侧订单号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="bizId" label="商户订单号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.bizId"
            placeholder="请输入商户订单号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="name" label="用户姓名">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.name"
            placeholder="请输入用户姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="payStatus" label="支付状态">
          <el-select
            style="width: 290px"
            v-model="formInline.payStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="未支付" value="1"></el-option>
            <el-option label="已支付" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderState" label="订单状态">
          <el-select
            style="width: 290px"
            v-model="formInline.orderState"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待支付" value="1"></el-option>
            <el-option label="待签约" value="2"></el-option>
            <el-option label="待评价" value="3"></el-option>
            <el-option label="订单完成" value="4"></el-option>
            <!-- <el-option label="订单关闭" value="5"></el-option> -->
            <el-option label="订单取消" value="6"></el-option>
            <el-option label="已退款" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="phone" label="用户手机号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.phone"
            placeholder="请输入用户手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="payType" label="支付方式">
          <el-select
            style="width: 290px"
            v-model="formInline.payType"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="易票联" value="YPL"></el-option>
            <el-option label="微信" value="WX"></el-option>
            <el-option label="支付宝" value="ZFB"></el-option>
            <el-option label="苹果" value="APPLE"></el-option>
            <el-option label="对公转账" value="DGZZ"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderSource" label="订单类别">
          <el-select
            style="width: 290px"
            v-model="formInline.orderSource"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="普通订单" value="1"></el-option>
            <el-option label="团购订单" value="2"></el-option>
            <el-option label="内训订单" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="materialsAuditStatus" label="参训材料审核状态">
          <el-select
            style="width: 290px"
            v-model="formInline.materialsAuditStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="审核中" value="1"></el-option>
            <el-option label="审核通过" value="2"></el-option>
            <el-option label="驳回" value="3"></el-option>
            <el-option label="不需要审核" value="9"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="payTime" label="支付时间">
          <my-datePicker
            width="290px"
            :scopeDate="formInline.payTime"
            @receiveMyDate="payTimeReceiveMyDate"
          />
        </el-form-item>
        <el-form-item prop="auditStatus" label="审核状态">
          <el-select
            style="width: 290px"
            v-model="formInline.auditStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="审核中" value="1"></el-option>
            <el-option label="通过" value="2"></el-option>
            <el-option label="驳回" value="3"></el-option>
            <el-option label="不需要审核" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="isFifteen" label="签约是否超过3天">
          <el-select
            style="width: 290px"
            v-model="formInline.isFifteen"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="divisionStatus" label="清分状态">
          <el-select
            style="width: 290px"
            v-model="formInline.divisionStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未完成" value="2"></el-option>
            <el-option label="已完成" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="isBalance" label="结算状态">
          <el-select
            style="width: 290px"
            v-model="formInline.isBalance"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未结算" value="1"></el-option>
            <el-option label="结算中" value="2"></el-option>
            <el-option label="已结算" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="isClearDivision" label="是否待清分">
          <el-select
            style="width: 290px"
            v-model="formInline.isClearDivision"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="companyId" label="所属租户">
          <el-select
            style="width: 290px"
            v-model="formInline.companyId"
            placeholder="请选择"
          >
            <el-option v-if="checkAdmin()" label="全部" value="-1"></el-option>
            <el-option
              v-for="item in companyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="$myStore.state.user.userIdentity === 1" prop="refundStatus" label="退费状态">
          <el-select
            style="width: 290px"
            v-model="formInline.refundStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="未退款" :value="1"></el-option>
            <el-option label="退款中" :value="2"></el-option>
            <el-option label="已退款" :value="3"></el-option>
            <el-option label="打款失败" :value="4"></el-option>
            <el-option label="已驳回" :value="5"></el-option>
            <el-option label="已取消退费" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="refundStatus" label="合约名称">
          <el-select
            style="width: 290px"
            v-model="formInline.splitContractId"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option v-for="item of splitContractList" :key="item.contractId" :label="item.contractName" :value="item.contractId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="isBalance" label="验收状态">
          <el-select
            style="width: 290px"
            v-model="formInline.acceptanceStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="可验收" value="1"></el-option>
            <el-option label="不可验收" value="2"></el-option>
            <el-option label="验收中" value="3"></el-option>
            <el-option label="已验收" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px">重置</el-button>
          <el-button style="margin-left: 8px" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-row v-if="!checkAdmin()" type="flex" align="middle">
        <el-switch
          v-model="toggleMutipleOperate"
          active-text="发起验收"
          :active-value="2"
          inactive-text="发起结算"
          :inactive-value="1"
          @change="handleToggleMutipleOperate"
        />&emsp;
        <el-button v-if="toggleMutipleOperate === 1" type="primary" :disabled="multipleSelection.length === 0" size="small" @click="handleMutipleBill">批量发起结算</el-button>
        <el-button v-else type="primary" :disabled="multipleSelection.length === 0" size="small" @click="handleMutipleReceipt">批量发起验收</el-button>&emsp;
        <span v-if="multipleSelection.length">已选: {{ multipleSelection.length }}单</span>
      </el-row>
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="data"
        border
        style="width:100%;margin-top:10px"
        :row-key="getRowKeys"
        @selection-change="handleSelectionChange"
      >
        <el-table-column v-if="!checkAdmin()" type="selection" :reserve-selection="true" :selectable="checkSelectable" width="55" align="center" fixed="left" />
        <el-table-column label="班级名称" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.skuName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.orderNumber || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属租户" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合约名称" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.splitContractName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单类别" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.orderSource === 1">普通订单</el-tag>
            <el-tag size="small" type="success" v-else-if="row.orderSource === 2">团购订单</el-tag>
            <el-tag size="small" type="success" v-else-if="row.orderSource === 3">内训订单</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="参训材料审核状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.materialsAuditStatus === 1">审核中</el-tag>
            <el-tag size="small" type="success" v-else-if="row.materialsAuditStatus === 2">审核通过</el-tag>
            <el-tag size="small" type="danger" v-else-if="row.materialsAuditStatus === 3">驳回</el-tag>
            <el-tag size="small" type="success" v-else-if="row.materialsAuditStatus === 9">不需要审核</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="用户昵称" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickname || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员姓名" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" minWidth="160" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="⽀付中⼼订单号(易票联)"
          width="176px"
        >
          <template slot-scope="{ row }">
            <span>{{ row.payOrderNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="渠道侧订单号(易票联)" width="176px">
          <template slot-scope="{ row }">
            <span>{{ row.outTradeNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="商户订单号" width="176px">
          <template slot-scope="{ row }">
            <span>{{ row.bizId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付类型" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.payType === 'YPL'">易票联</el-tag>
            <el-tag size="small" v-else-if="row.payType === 'APPLE'">苹果</el-tag>
            <el-tag size="small" v-else-if="row.payType === 'DGZZ'">线下转账</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.payStatus === 1">未支付</el-tag>
            <el-tag size="small" v-else-if="row.payStatus === 2" type="success">已支付</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="签约是否超过3天" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.isFifteen === 1">是</el-tag>
            <el-tag size="small" v-else-if="row.isFifteen === 2" type="warning">否</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="是否待清分" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.isClearDivision === 1">是</el-tag>
            <el-tag size="small" v-else-if="row.isClearDivision === 2" type="warning">否</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="清分状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.divisionStatus === 2" type="warning">未完成</el-tag>
            <el-tag size="small" v-else-if="row.divisionStatus === 1" type="success">已完成</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="结算状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.isBalance === 1">未结算</el-tag>
            <el-tag size="small" v-else-if="row.isBalance === 2" type="success">结算中</el-tag>
            <el-tag size="small" v-else-if="row.isBalance === 3" type="success">已结算</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结算单id" width="176px">
          <template slot-scope="{ row }">
            <span>{{ row.balanceId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="验收状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.acceptanceStatus === 1">可验收</el-tag>
            <el-tag size="small" type="danger" v-else-if="row.acceptanceStatus === 2">不可验收</el-tag>
            <el-tag size="small" v-else-if="row.acceptanceStatus === 3">验收中</el-tag>
            <el-tag size="small" type="success" v-else-if="row.acceptanceStatus === 4">已验收</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.orderState === 1">待支付</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 2" type="success">待签约</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 3">待评价</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 4" type="warning">订单完成</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 5" type="info">订单关闭</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 6" type="info">订单取消</el-tag>
            <el-tag size="small" v-else-if="row.orderState === 7" type="danger">已退款</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payTime || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payAmt || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单来源" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.sourceType === 1">PC</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 2" type="success">小程序</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 3" type="info">安卓</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 4" type="danger">ios</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 5" type="warning">H5</el-tag>
            <el-tag size="small" v-else-if="row.sourceType === 6" type="warning">后台</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="退款状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.refundStatus === 1">未退款</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 2" type="info">退款中</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 3" type="success">已退款</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 4" type="danger">打款失败</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 5" type="warning">已驳回</el-tag>
            <el-tag size="small" v-else-if="row.refundStatus === 6" type="info">已取消退费</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="是否签约" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.signType === 1">未签约</el-tag>
            <el-tag size="small" v-else-if="row.signType === 2" type="success">签约</el-tag>
            <el-tag size="small" v-else-if="row.signType === 3" type="info">没有合同</el-tag>
            <el-tag size="small" v-else-if="row.signType === 4" type="danger">协议签约中</el-tag>
            <el-tag size="small" v-else-if="row.signType === 5" type="warning">暂不用签约</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" v-if="row.auditStatus === 1">审核中</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 2" type="success">审核通过</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 3" type="danger">驳回</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 9" type="warning">不需要审核</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 30">教务审核中</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 40" type="danger">教务审核驳回</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 50">财务审核中</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 60" type="danger">财务审核驳回</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 70">项目负责人审核中</el-tag>
            <el-tag size="small" v-else-if="row.auditStatus === 80" type="danger">项目负责人审核驳回</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="是否提交发票信息" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info" v-if="row.invoiceApplyStatus === 1">否</el-tag>
            <el-tag size="small" type="success" v-else-if="row.invoiceApplyStatus === 2">是</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column width="246" fixed="right" label="操作">
          <template slot-scope="{ row }">
            <!-- <span v-if="!checkAdmin()" class="blue_Box" @click="handleBill(row)">发起结算</span> -->
            <span class="blue_Box" @click="openOrderDetail(row)">订单详情</span>
            <span
              class="blue_Box"
              v-if="row.payStatus === 2 && row.isBalance !== 2"
              @click="openCreateRefund(row)"
            >创建退费工单</span>
            <span class="blue_Box" @click="reSign(row.id)">重新签协议</span>
            <span class="blue_Box" @click="showMaterials(row.id)">查看参训材料</span>
            <span v-if="$hasAuthority('app1_change_accept_status')" class="blue_Box" @click="toChangeAcceptStatus(row.id)">修改验收状态</span>
            <span class="blue_Box" v-if="$hasAuthority('app1_change_accept_status') && [3,4].includes(row.acceptanceStatus)" @click="showAcceptDetail(row.id)">验收详情</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 订单详情 -->
    <OrderDetail ref="orderDetailRef" />
    <!-- 创建退费工单 -->
    <CreateRefund ref="createRefundRef" />
    <!-- 导出 -->
    <FileExport ref="FileExport" />
    <!-- 参训审核材料 -->
    <MaterialsInfo ref="materialsInfoRef" />
    <!-- 修改验收状态 -->
    <ChangeAcceptanceStatus ref="changeAcceptanceStatusRef" @refresh="refresh" />
    <!-- 验收单详情 -->
    <BillDetail ref="BillDetailEl" />
  </div>
</template>

<script>
import FileExport from "@/components/FileExport.vue";
import {
  getOrderListPage,
  getSelectCompanyList,
  resignAgreement,
  addBillOrder,
  addAcceptanceOrder
} from "@/api/orderAdmin/orderList";
import { getAppUserInfo } from "@/api/common";
import { getSplitContractList } from "@/api/organization"
import myPagination from "@/components/myPagination.vue";
import myDatePicker from "@/components/myDatePicker.vue";
import CreateRefund from "@/views/refund/components/createRefund.vue";
import OrderDetail from "@/views/orderAdmin/components/orderDetail.vue";
import MaterialsInfo from '@/views/orderAdmin/components/materials.vue'
import ChangeAcceptanceStatus from '@/views/orderAdmin/components/changeAcceptanceStatus.vue'
import BillDetail from '../components/billDetail.vue'
import { clone, processing } from "@/utils/handle.js";
import dayjs from 'dayjs'

export default {
  name: "OrderList",
  components: {
    myPagination,
    myDatePicker,
    OrderDetail,
    CreateRefund,
    MaterialsInfo,
    ChangeAcceptanceStatus,
    BillDetail,
    FileExport,
  },
  data() {
    return {
      loading: false,
      formInline: {
        orderNumber: "",
        orderSource: "-1",
        materialsAuditStatus: "-1",
        orderState: "-1",
        payTime: [],
        payStartTime: "",
        payEndTime: "",
        name: "",
        phone: "",
        outTradeNo: "",
        bizId: "",
        skuName: "",
        payStatus: "",
        auditStatus: "-1",
        isFifteen: "-1",
        isClearDivision: "-1",
        isBalance: "-1",
        payType: "-1",
        companyId: "-1",
        refundStatus: "-1",
        splitContractId: "-1",
        acceptanceStatus: "-1",
      },
      toggleMutipleOperate: 1,
      splitContractList: [],
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      companyData: [],
      multipleSelection: []
    };
  },
  mounted() {
    this.handleGetSplitContractList();
    this.getSelectCompanyList();
  },
  methods: {
    // 手机号
    phoneRE(payload) {
      if (!payload) return "--";
      return payload.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
    },
    // 导出
    handleExport() {
      this.$refs.FileExport.init(
        this.searchData, // 搜索表单参数
        "jsw-order-provider", // 后端对应业务线服务
        "/order/adm/order/testDown", // 导出-对应的接口
        1, //  状态：0get、1post
        "订单统计.xlsx" //文件名称
      );
    },
    // 租户列表
    getSelectCompanyList() {
      getSelectCompanyList().then((res) => {
        if (res.code === 0) {
          this.companyData = res.data || [];
          this.formInline.companyId = res.data[0]?.id;
          this.searchData.companyId = res.data[0]?.id;
          this.getOrderListPage({
            page: 1,
            limit: 10,
            companyId: this.formInline.companyId,
          });
        }
      });
    },
    // 创建退费工单
    openCreateRefund(payload) {
      this.$refs.createRefundRef.init("add", payload);
    },
    // 重新签协议
    reSign(orderId) {
      this.$confirm(`确定要重新签订协议吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        resignAgreement({ orderId }).then(({ code, message }) => {
          if (code === 0) {
            this.$message.success('操作成功！')
          } else {
            this.$message.error(message)
          }
        })
      })
    },
    // 查看参训审核材料
    showMaterials(orderId) {
      this.$refs.materialsInfoRef.init({ orderId })
    },
    // 修改验收状态
    toChangeAcceptStatus(orderId) {
      this.$refs.changeAcceptanceStatusRef.init(orderId)
    },
    // 验收详情
    showAcceptDetail(orderId) {
      this.$refs.BillDetailEl.init(orderId)
    },
    // 订单详情
    openOrderDetail(payload) {
      this.$refs.orderDetailRef.init(payload.id)
    },
    // 刷新
    refresh() {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 列表请求
    async getOrderListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      delete payload.payTime;
      const res = await getOrderListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 切换批量操作
    handleToggleMutipleOperate () {
      // 重置数据
      this.handleCurrentChange(this.pageInfo.page)
      // 重置选择
      this.$refs.multipleTable.clearSelection()
    },
    // 列表选择
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 发起批量结算
    handleMutipleBill () {
      if (this.multipleSelection.length < 1) {
        this.$message.warning('批量结算最少1笔，请重新选择!')
        return
      }
      const indexId = this.multipleSelection[0].splitContractId
      if (this.multipleSelection.every(({ splitContractId }) => splitContractId !== indexId)) {
        this.$message.warning('不同合约id的订单不可同时结算，请选择相同id的订单发起!')
        return
      }
      this.$confirm(`是否确认批量提交结算?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const orderIds = this.multipleSelection.map(({ id }) => id).join(',')
        const params = { orderIds }
        addBillOrder(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('批量发起结算成功!')
            this.$refs.multipleTable.clearSelection()
          }
        })
      })
    },
    // 发起批验收
    handleMutipleReceipt () {
      if (this.multipleSelection.length < 10) {
        this.$message.warning('批量验收最少10笔，请重新选择!')
        return
      }
      const indexId = this.multipleSelection[0].balanceId
      if (this.multipleSelection.every(({ balanceId }) => balanceId !== indexId)) {
        this.$message.warning('不同结算单id的订单不可同时验收，请选择相同结算单id的订单发起!')
        return
      }
      this.$confirm(`是否确认批量发起验收单?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const orderIds = this.multipleSelection.map(({ id }) => id).join(',')
        const params = { orderIds }
        addAcceptanceOrder(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('批量发起验收成功!')
            this.$refs.multipleTable.clearSelection()
          }
        })
      })
    },
    // 发起结算
    handleBill (row) {
      if (row.isFifteen !== 1) {
        this.$message.warning('当前订单学员签约不满3天, 无法发起结算申请!')
        return
      }
      if (row.isBalance !== 1) {
        this.$message.warning('当前订单非未结算状态，无法发起结算申请!')
        return
      }
      if (row.payType !== 'YPL') {
        this.$message.warning('当前订单非易票联支付，无法发起结算申请!')
        return
      }
      if (row.isClearDivision !== 1) {
        this.$message.warning('当前订单非待清分状态，无法发起结算申请!')
        return
      }
      this.$confirm(`是否确认提交结算?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          orderIds: row.id
        }
        addBillOrder(params).then(({ code }) => {
          if (code === 0) {
            this.$message.success('发起结算成功!')
          }
        })
      })
    },
    getRowKeys (row) {
      return row.id
    },
    checkSelectable(row) {
      if (this.toggleMutipleOperate === 2) {
        return row.isBalance === 3 &&
          row.acceptanceStatus === 1 &&
          dayjs(row.payTime).isBefore(dayjs(), 'month')
      }
      return row.isBalance === 1 &&
        row.isFifteen === 1 &&
        row.payType === 'YPL' &&
        row.isClearDivision === 1 &&
        [1,6].includes(row.refundStatus)
    },
    // 支付时间
    payTimeReceiveMyDate(payload) {
      this.formInline.payTime = payload;
      this.formInline.payStartTime = payload[0] + " 00:00:00";
      this.formInline.payEndTime = payload[1] + " 23:59:59";
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getOrderListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.formInline.payTime = [];
      this.formInline.payStartTime = "";
      this.formInline.payEndTime = "";
      this.$refs["formInline"].resetFields();
      this.$refs.multipleTable.clearSelection()
      this.getSelectCompanyList();
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
    // 获取合约状态
    async handleGetSplitContractList () {
      const res = await getSplitContractList()
      this.splitContractList = res.data || [];
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.orderList {
  .blue_Box {
    white-space: nowrap;
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
